module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.enabled) ? _c('div', {
    staticClass: "student"
  }, [_c('router-view'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.countdown),
      expression: "countdown"
    }],
    ref: "countdown",
    staticClass: "countdown"
  }, [_c('h1', [_vm._v(_vm._s(_vm.count))])]), _vm._v(" "), (_vm.namecard) ? _c('div', {
    staticClass: "name-wrap"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', [_vm._v("请输入你的名字")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "name": "name",
      "placeholder": "请输入你的名字"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.intoRoom
    }
  }, [_vm._v("进入房间")])])]) : _vm._e(), _vm._v(" "), (_vm.answer) ? _c('div', {
    staticClass: "answer-wrap"
  }, [_c('div', {
    staticClass: "a-tip"
  }, [_c('h1', [_vm._v("随堂问卷")]), _vm._v(" "), _c('p', [_vm._v("问卷：" + _vm._s(_vm.question))]), _vm._v(" "), _c('pre', {
    staticClass: "question-content",
    domProps: {
      "innerHTML": _vm._s(_vm.codeFixed)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "code-wrap"
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.selectYes
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.selectNo
    }
  }, [_vm._v("No")])])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc4ceb22","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/student/student.vue
// module id = 525
// module chunks = 1